<template>
  <span class="order-notifier"></span>
</template>

<script>
import { notifyOrder } from '@/api/order'

const STORAGE_KEY = 'admin_order_notify_last_id'
const POLL_INTERVAL = 15000

export default {
  name: 'OrderNotifier',
  data () {
    return {
      timer: null,
      lastId: -1,
      audioCtx: null
    }
  },
  mounted () {
    const saved = window.localStorage.getItem(STORAGE_KEY)
    this.lastId = saved === null ? -1 : Number(saved)
    document.addEventListener('click', this.unlockAudio)
    this.poll()
    this.timer = setInterval(this.poll, POLL_INTERVAL)
  },
  beforeDestroy () {
    clearInterval(this.timer)
    document.removeEventListener('click', this.unlockAudio)
  },
  methods: {
    unlockAudio () {
      this.ensureAudioContext()
    },
    ensureAudioContext () {
      const Ctx = window.AudioContext || window.webkitAudioContext
      if (!Ctx) return null
      if (!this.audioCtx) this.audioCtx = new Ctx()
      if (this.audioCtx.state === 'suspended') this.audioCtx.resume()
      return this.audioCtx
    },
    beep () {
      const ctx = this.ensureAudioContext()
      if (!ctx) return
      const play = (start, freq, duration) => {
        const osc = ctx.createOscillator()
        const gain = ctx.createGain()
        osc.type = 'sine'
        osc.frequency.value = freq
        gain.gain.setValueAtTime(0.0001, ctx.currentTime + start)
        gain.gain.exponentialRampToValueAtTime(0.3, ctx.currentTime + start + 0.02)
        gain.gain.exponentialRampToValueAtTime(0.0001, ctx.currentTime + start + duration)
        osc.connect(gain)
        gain.connect(ctx.destination)
        osc.start(ctx.currentTime + start)
        osc.stop(ctx.currentTime + start + duration + 0.02)
      }
      play(0, 880, 0.18)
      play(0.22, 1175, 0.22)
    },
    async poll () {
      try {
        const data = await notifyOrder(this.lastId)
        if (!data) return
        const maxId = Number(data.maxId) || 0
        // 首次加载：只记录基线，不提醒历史订单
        if (this.lastId < 0) {
          this.lastId = maxId
          this.persist()
          return
        }
        const orders = data.orders || []
        if (orders.length) {
          this.beep()
          orders.slice(-3).forEach(o => this.popup(o))
          this.lastId = maxId
          this.persist()
        } else if (maxId > this.lastId) {
          this.lastId = maxId
          this.persist()
        }
      } catch (e) { /* 轮询失败静默重试 */ }
    },
    popup (order) {
      const amount = order.payAmount == null ? '' : '｜¥' + (Number(order.payAmount) / 100).toFixed(2)
      const message = `${order.memberName || '游客'} 咨询 ${order.staffName || '-'}｜${order.contactPhone || '无手机号'}${amount}`
      this.$notify({
        title: '新的咨询订单',
        message: `${message}（点击查看并处理）`,
        type: 'warning',
        position: 'bottom-right',
        duration: 12000,
        offset: 16,
        onClick: () => { this.$router.push('/order/list') }
      })
    },
    persist () {
      window.localStorage.setItem(STORAGE_KEY, String(this.lastId))
    }
  }
}
</script>

<style scoped>
.order-notifier {
  display: none;
}
</style>
